const INSERT_CODE_BLOCK_BUTTON = "insert-code-block-button";
const TEXT_BUTTON_CODE_BLOCK = "text-button-code-block";
const ROOT = "code-block";
export {
  INSERT_CODE_BLOCK_BUTTON,
  ROOT,
  TEXT_BUTTON_CODE_BLOCK
};
//# sourceMappingURL=data-hooks.js.map
